import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React, { Component } from 'react';
import { LocalForm } from 'react-redux-form';
import PropTypes from 'prop-types';
import AlertTranslationApprove from '../../container/AlertTranslationApprove';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import Spinner from '../Snowflake/as/Spinner';

const messages = defineMessages({
  htmlHeader: {
    id: 'confirmation.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Comfirmation'
  },
  headerTitle: {
    id: 'translationapproval.header.title',
    description: 'Page Header Title',
    defaultMessage: 'Commercial code translation approval'
  },
  headerSubTitle: {
    id: 'translationapproval.header.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'Approve code translation professional service'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

class TransApproveMsg extends Component {
  //const { intl } = props;
  static propTypes = {
    clickOKHandler: PropTypes.func.isRequired,
    approvetranslation: PropTypes.func.isRequired
  };
  //const fileList = project.files;
  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state ={
      show:true
    }
  }

  componentDidMount() {
    this.props.approvetranslation(
      this.props.reference_id,
      this.props.opportunity_num,
      this.props.translationRate,
      this.props.username
    );

    this.setState({show:false})

      // setTimeout(function () {      

      //    this.setState({show:false});
      //   }, 2000);
    //this.setState({show:false});
  }

  render() {
    return (
      <div className="preview page">
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT
          </title>
        </Helmet>
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          //locale={this.props.locale}
        />
        <AlertTranslationApprove
        title="Error"
          // title={this.props.intl.formatMessage(messages.htmlHeader)}
          message={print(this.props.status)}
        />
        <div className="main">
          <div
            className="panel"
            style={{
              width: '60%',
              padding: '40px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            <LocalForm>
              <div className="form">
                <label
                  style={{
                    width: '90%',
                    fontSize: '14px',
                    textTransform: 'none',
                    lineHeight: '150%',
                    color: '#797979'
                  }}
                >
                  {/* You have approved a Commercial Code Translation for the
                  Quotation Report with Quotation ID {this.props.quotation_id} */}
                  You have approved a Commercial Code Translation Release for the reference ID {this.props.reference_id}
                  .​ <br />
                  {/* <br />
                  The PO number for this order is {this.props.po_num}
                  .​ <br /> */}
                  <br />
                  The source code has been successfully copied to a protected
                  and controlled repository named {this.props.reponame}
                  .​ <br />
                  <br />
                  The confirmation notification emails have been sent to the
                  Snowflake engineer who requested this service and yourself.
                </label>

                <br />
                <br />
                <div
                  className="button-container"
                  style={{ textAlign: 'center' }}
                >
                  <button
                    className="button"
                    styel={{ padding: 20 }}
                    onClick={() => this.props.clickOKHandler()}
                  >
                    <FormattedMessage id="nav.ok" defaultMessage="OK" />
                  </button>
                </div>
              </div>
            </LocalForm>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default injectIntl(TransApproveMsg);



// WEBPACK FOOTER //
// ./src/components/views/TransApproveMsg/index.js